import React from "react"
import ModuleCards from "./moduleCards"
const AccountingSetup=()=>{
    return(
        <ModuleCards/>
    )
}

export default AccountingSetup